class ProductSupport extends HTMLElement {
  constructor() {
      super()
      console.log("[Product Support] Component constructed")
      this._fetchTimer = null;
      this._fetchInFlight = false;
      this._refetchAfterInFlight = false;
  }
  connectedCallback() {
      this.setVariables()
  }

  static get observedAttributes() {
      return ['sku', 'model'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
      if (oldValue === newValue) return;

      if (name === 'sku') {
          if (typeof newValue === "string" && newValue.trim() !== "") {
              this.sku = newValue;
              console.log("[Product Support] Sku changed from", oldValue, "to", newValue);
          }
      }

      if (name === 'model') {
          if (typeof newValue === "string" && newValue.trim() !== "") {
              this.model = newValue;
              console.log("[Product Support] Model changed from", oldValue, "to", newValue);
          }
      }

      if (this.sku || this.model) {
          if (this._fetchTimer) clearTimeout(this._fetchTimer);
          this._fetchTimer = setTimeout(() => {
              this._fetchTimer = null;
              if (!this._fetchInFlight) {
                  this.fetchProductSupportInfo({ replace: true });
              } else {
                  // If a fetch is already running, queue one more run
                  this._refetchAfterInFlight = true;
              }
          }, 50);
      }
  }

  async fetchProductSupportInfo(options = { replace: false }) {
      if (this._fetchInFlight) {
          console.log("[Product Support] Fetch already in progress; skipping.");
          return;
      }
      this._fetchInFlight = true;
      try {
          if (options.replace === true) {
              viewTransition(() => {
                  this.querySelector('div.product-support-tabs').innerHTML = `<p>Loading...</p>`;
              });
          }

          const tryFetch = async (modelParam) => {
              try {
                  const response = await fetch(`https://help.na.panasonic.com/wp-json/api/shopify/v1/products?model=${modelParam}`, {
                      method: "GET",
                      headers: {
                          "Content-Type": "application/json",
                          "Authorization": "Basic RWxsaW90IFJvdGg6RkROZiA2Mmp4IDZRSHYgbDBYYiBIWHAxIGpKRTE="
                      }
                  });
                  const data = await response.json();
                  if (data && !data.error && Object.keys(data).length > 0) {
                      return data;
                  }
              } catch (err) {
                  console.error(`[Product Support] Fetch error for ${modelParam}:`, err);
              }
              return null;
          };
          const hasData = (v) => v && !v.error && typeof v === "object" && Object.keys(v).length > 0;
          let data = null;
          if(!this.model) console.log("[Product Support] No model provided")

          if (this.sku) {
              // Try by SKU first
              console.log("[Product Support] Attempting fetch by SKU:", this.sku);
              const bySku = await tryFetch(this.sku);
              console.log("[Product Support] Fetched data by SKU:", bySku);
              if (hasData(bySku)) data = bySku;
          }

          // If no usable data, try by model
          if (!data && this.model) {
              console.log("[Product Support] Attempting fetch by model:", this.model);
              const byModel = await tryFetch(this.model);
              console.log("[Product Support] Fetched data by model:", byModel);
              if (hasData(byModel)) data = byModel;
          }

          if (data) {
              if (this.style.display === "none") this.style.display = "block";
              this.supportInfo = data;
              await this.renderSupportTabs(data);
              await this.addEventListeners();
          } else {
              console.warn("[Product Support] No support data found for SKU or model.");
              viewTransition(() => this.style.display = "none");
          }
      } finally {
            this._fetchInFlight = false;
            if(this._refetchAfterInFlight) {
                this._refetchAfterInFlight = false;
                // Run one final fetch with the latest attributes
                this.fetchProductSupportInfo({ replace: true });
            } 
        
            this.setActiveTab(document.querySelector(`button#product-support-tab-1`))
      }
  }
  
  setVariables() {
      // this.endpoint = "https://technics-product-support-proxy-server.azurewebsites.net"
      // this.endpoint = "https://panasonic-stage.bluechiplabs.io/wp-json/api/shopify/v1/products"
      // this.sku = this.getAttribute('sku')
      this.activeTab = null
  }
  addEventListeners() {
      this.modal = this.querySelector('dialog#answer-content')
      this.tabsContainer = this.querySelector('div.product-support-tabs')
      this.tabContentContainer = this.querySelector('.product-support-content')
      this.tabButtons = this.querySelectorAll('button.product-support-tab')
      this.tabButtons.forEach(tabButton => tabButton.addEventListener('click', this.handleTabClick.bind(this)))
      document.addEventListener('variant:changed', e => {
          const selectedVariant = e.detail.variant;
          console.log("[Product Support] Variant changed: ", selectedVariant);
          this.setAttribute('model', selectedVariant.sku)
      })
      this.modal.addEventListener("click", e => {
          const dialogDimensions = this.modal.getBoundingClientRect()
          if (
            e.clientX < dialogDimensions.left ||
            e.clientX > dialogDimensions.right ||
            e.clientY < dialogDimensions.top ||
            e.clientY > dialogDimensions.bottom
          ) {
              this.modal.close()
          }
      })
  }

  openModal() {
      if (this.modal) viewTransition(() => this.modal.showModal())
  }

  closeModal() {
      if (this.modal) viewTransition(() => {
          this.modal.close()
          this.modal.innerHTML = ''
      })
  }

  renderSupportTabs(data) {
    const tabs = data?.answers?.map(({ name }) => name) || []
    // console.log("render support tabs: ", data, tabs)
    if(!tabs.length) return
    const supportTabsContainer = this.querySelector('div.product-support-tabs')
    supportTabsContainer.innerHTML = '' // clear existing data in case previous variant has been selected
    tabs?.forEach((tab, idx) => supportTabsContainer.innerHTML += `
        <div class="product-support-tab-container">
            <button 
                class="product-support-tab"
                id="product-support-tab-${idx + 1}"
                data-tab-title="${tab}"
            >
                ${tab}
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                    <path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
                </svg>
            </button>
            <div class="product-support-tab-content" data-tab-title="${tab}"> </div>
    `)

  }

  handleTabClick(e) {
      const clickedTab = e.target;
    //   console.log("handleTabClick: ", clickedTab)
      if(clickedTab) this.setActiveTab(clickedTab)
  }

  setActiveTab(newTab) {
    const previousTabContent = this.activeTab
    ? this.querySelector(`.product-support-tab-content[data-tab-title="${this.activeTab.getAttribute('data-tab-title')}"]`)
    : null;

    viewTransition(() => {
        // Clear previous tab content
        if (previousTabContent) {
            previousTabContent.innerHTML = '';
            previousTabContent.classList.remove('active');
        }
        if (this.activeTab) this.activeTab.classList.remove('active');

        // Toggle content visibility for the clicked tab
        if (this.activeTab === newTab) this.activeTab = null; // Deselect the tab
        else {
            newTab.classList.add('active');
            this.activeTab = newTab;
            this.updateSupportContent(); // Load new content
        }
    });
  }
  
  async handleAnswerClick(e) {
      e.preventDefault();
      const url = e.target.getAttribute('data-url');
  
      if(url.includes('download') || url.toLowerCase().endsWith('.pdf')) {
          // open the url in a new tab for downloads or PDFs
          return window.open(url, '_blank');
      }
  
      const fetchHtmlContent = async () => {
          try {
              const response = await fetch(url);
              const data = await response.text();
              const parser = new DOMParser();
              return parser.parseFromString(data, 'text/html');
          } catch (error) {
              console.error("Error in fetchHtmlContent:", error);
              window.open(url, '_blank');
          }
      }

      // create an iframe to load the content in the modal
      const iframe = document.createElement('iframe');
      // iframe.setAttribute('sandbox', 'allow-same-origin allow-popups');
      iframe.style.width = '100%';
      iframe.style.height = '100%';
      
      if(url.includes('http://')) {
          // console.log("replace http with https")
          iframe.src = url.replace('http://', 'https://');
      } else {
          // console.log("load url in iframe: ", url)
          iframe.src = url
      }

  
      // const htmlDoc = await fetchHtmlContent();
  
      // const mainContent = htmlDoc.querySelector('main')?.innerHTML || '<p>No content available</p>';

      // // Create container for Shadow DOM
      // const shadowHost = document.createElement('div');
      // const shadowRoot = shadowHost.attachShadow({ mode: 'open' });
  
      // // Add external stylesheets into shadow root
      // const styles = htmlDoc.querySelectorAll('link[rel="stylesheet"], style');
      // styles.forEach(styleEl => {
      //     shadowRoot.appendChild(styleEl.cloneNode(true));
      // });
  
      // // Add main content
      // const contentContainer = document.createElement('div');
      // contentContainer.innerHTML = mainContent;
      // contentContainer?.querySelector('div.breadcrumb')?.remove()
      // shadowRoot.appendChild(contentContainer);
  
      // Clear modal content and add shadow host
      this.modal.innerHTML = '';
      // this.modal.appendChild(shadowHost);
      this.modal.appendChild(iframe);
  
      this.openModal();
  }

  updateBlocks(activeTabName) {
    const allSupportBlocks = this.querySelectorAll('.product-support-info[data-tab-title]')
    Array.from(allSupportBlocks)?.filter(b => b.dataset.activeTabName != activeTabName)?.forEach(el => el.classList.remove('active'))
    const supportInfo = this.querySelector(`.product-support-info[data-tab-title="${activeTabName}"]`);
    if(supportInfo) {
        supportInfo.classList.add('active')
    }
  }

  handleDesktopTabContent(activeTabName, answersMarkup) {
    this.tabContentContainer.innerHTML = answersMarkup
    this.updateBlocks(activeTabName)
  }
  handleMobileTabContent(activeTabName, answersMarkup) {
      const mobileTabContent = this.querySelector(`.product-support-tab-content[data-tab-title="${activeTabName}"`)
      const supportingInfoContent = this.querySelector(`.${activeTabName.replace(/\s/g, '-')}-info`)
      mobileTabContent.classList.add('active')
      if(supportingInfoContent && answersMarkup) mobileTabContent.innerHTML = `
          <div class="supporting-info" style="margin: 20px 0;">
              ${supportingInfoContent.innerHTML}
          </div>
          ${answersMarkup}
      `
      else mobileTabContent.innerHTML = answersMarkup || '<p>No content available</p>'
  }

  updateSupportContent() {
      if (!this.activeTab) return; // Exit if no active tab
  
      const activeTabName = this.activeTab.getAttribute('data-tab-title');
      // TODO: update filtering of answers to use a new answer object property (e.g. category) - to be added to API by client
      var tabAnswers = this.supportInfo?.answers?.find(({ name }) =>
          name.toLowerCase()?.includes(activeTabName.split(' ')[0]?.toLowerCase())
      );
      const { answers, name, slug, term_id } = tabAnswers;
      // console.log("updateSupportContent: ", activeTabName, tabAnswers)

      // Create fake answers to test the UI based on Su's design
    //   if(activeTabName === "Manuals and Specifications" && !tabAnswers?.length) tabAnswers = [ { title: "Quick Start Guide", url: "#", id: "1", type: "file" }, { title: "Owner's Manual", url: "#", id: "2", type: "file" }]

      const answersMarkup = answers?.length
          ? answers.map(({ id, title, url }) => `
              <a 
                  target="_blank"
                  class="product-support-answer" 
                  data-answer-id="${id}"
                  data-url="${url}"
                  data-tab="${activeTabName}"
              >
                  ${title}
              </a>
          `).join('')
          : '<p>No content available</p>';
  
      this.handleDesktopTabContent(activeTabName, answersMarkup);
      this.handleMobileTabContent(activeTabName, answersMarkup);
      this.querySelectorAll('.product-support-answer').forEach(answer => answer.addEventListener('click', this.handleAnswerClick.bind(this)))

  }
  
}

if(!customElements.get('product-support')) {
  customElements.define('product-support', ProductSupport)
}